/* eslint-disable react/jsx-no-target-blank */
/* eslint-disable jsx-a11y/anchor-is-valid */
import { FC, useState } from 'react'
import { Link } from 'react-router-dom'
import clsx from 'clsx'
import { useLayout } from '../../core'
import { KTSVG } from '../../../helpers'
import { AsideMenu } from './AsideMenu'
import AppDownloadModal from '../../../../app/components/Modals/AppDownloadModal'
import { AnnouncementBanner } from '../../../../app/components/AnnouncementBanner'

const AsideDefault: FC = () => {
  const {  classes } = useLayout()
  // const { aside } = config
  const [showAppModal, setShowAppModal] = useState(false)

  return (
    <div
      id='kt_aside'
      className={clsx('aside', classes.aside.join(' '))}
      data-kt-drawer='true'
      data-kt-drawer-name='aside'
      data-kt-drawer-activate='{default: true, lg: false}'
      data-kt-drawer-overlay='true'
      data-kt-drawer-width="{default:'200px', '300px': '250px'}"
      data-kt-drawer-direction='start'
      data-kt-drawer-toggle='#kt_aside_mobile_toggle'
    >
      {/* begin::Brand */}
      {/* <div className='aside-logo flex-column-auto' id='kt_aside_logo'>
       
        {aside.theme === 'dark' && (
          <Link to='/home'>
            <img
              alt='Logo'
              className='h-50px logo mt-3'
              src={toAbsoluteUrl('/media/logos/b4igo-logo-alpha.png')}
            />
          </Link>
        )}
        {aside.theme === 'light' && (
          <Link to='/home'>
            <img
              alt='Logo'
              className='h-25px logo'
              src={toAbsoluteUrl('/media/logos/logo-1.svg')}
            />
          </Link>
        )}
      
        {aside.minimize && (
          <div
            id='kt_aside_toggle'
            className='btn btn-icon w-auto px-0 btn-active-color-primary aside-toggle bg-transparent'
            data-kt-toggle='true'
            data-kt-toggle-state='active'
            data-kt-toggle-target='body'
            data-kt-toggle-name='aside-minimize'
          >
            <KTSVG
              path={'/media/icons/duotune/arrows/arr080.svg'}
              className={'svg-icon-1 rotate-180'}
            />
          </div>
        )}
   
      </div> */}
      {/* end::Brand */}

      {/* begin::Aside menu */}
      <div className='aside-menu flex-column-fluid'>
        <AsideMenu asideMenuCSSClasses={classes.asideMenu} />
      </div>
      {/* end::Aside menu */}

      {/* begin::Footer */}
      <div className='aside-footer flex-column-auto pt-5 pb-7 px-5' id='kt_aside_footer'>
        <AnnouncementBanner />
        <button
          onClick={() => setShowAppModal(true)}
          className={`btn btn-custom w-100 mb-2 text-white`}
          data-bs-toggle='tooltip'
          data-bs-trigger='hover'
          data-bs-dismiss='click'
          title='Download b4igo mobile app'
        >
          <span className='btn-label text-white'>
            <i className={`bi bi-phone me-2 text-white`}></i>
            Mobile app
          </span>
        </button>
        <Link
          to='/feedback'
          className='btn btn-custom btn-primary w-100'

          data-bs-toggle='tooltip'
          data-bs-trigger='hover'
          data-bs-dismiss='click'
          title='Check out the complete documentation with over 100 components'
        >
          <span className='btn-label'>Feedback</span>
          <span className='svg-icon btn-icon svg-icon-2'>
            <KTSVG path='/media/icons/duotune/general/gen005.svg' />
          </span>
        </Link>
        <div className='mt-2 text-white text-center copyright_text'>2023 - 2026 b4igo.ai. <br />All rights reserved</div>
      </div>
      {/* end::Footer */}

      <AppDownloadModal show={showAppModal} onHide={() => setShowAppModal(false)} />
    </div>
  )
}

export { AsideDefault }
